import React from 'react';
import { actionColumnId, AddressConfirmationTableRow, columnDefs } from './Columns';
import { useTable } from '@datavant/uikit';
import { getCoreRowModel, getPaginationRowModel, getSortedRowModel } from '@tanstack/react-table';
import { AddressConfirmationTable } from './AddressConfirmationTable';

export const AddressConfirmation = ({
    isLoading,
    data,
    shouldShowAction = false,
    autoResetPageIndex = true,
}: {
    isLoading: boolean;
    data: AddressConfirmationTableRow[];
    shouldShowAction?: boolean;
    autoResetPageIndex?: boolean;
}) => {
    const table = useTable<AddressConfirmationTableRow>({
        data,
        columns: columnDefs,
        state: {
            columnVisibility: {
                [actionColumnId]: shouldShowAction,
            },
        },
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        autoResetPageIndex,
    });

    return <AddressConfirmationTable table={table} isLoading={isLoading} />;
};
